import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import validate from 'validate.js';
import _ from 'underscore';
import compose from 'recompose/compose';
import validators from 'common/validators';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Button, TextField, CircularProgress } from '@material-ui/core';

// Shared components
import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
  PortletFooter
} from 'components';

import { updatePassword } from "../../../../actions/authActions";

// Component styles
import styles from './styles';
import schema from './schema';

validate.validators.checked = validators.checked;

class AccountResetPassword extends Component {
  state = {
    values: {
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
    },
    touched: {
        currentPassword: false,
        newPassword: false,
        confirmNewPassword: false,
    },
    errors: {
        currentPassword: null,
        newPassword: null,
        confirmNewPassword: null,
    },
    loading: false,
    isValid: false,
  };

  validateForm = _.debounce(() => {
    const { values } = this.state;

    const newState = { ...this.state };
    const errors = validate(values, schema);

    newState.errors = errors || {};
    newState.isValid = errors ? false : true;

    this.setState(newState);
  }, 300);

  handleFieldChange = (field, value) => {
    const newState = { ...this.state };

    newState.touched[field] = true;
    newState.values[field] = value;

    this.setState(newState, this.validateForm);
  };

  handleResetPassword = async () => {
    try {
      const { values } = this.state;
      this.setState({loading:true});
      await this.props.updatePassword({
          password: values.currentPassword,
          newPassword: values.newPassword,
          email: this.props.auth.user.email
      });
      this.setState({loading:false});
      window.alert('Reset password successfully!');
    } catch (error) {
      this.setState({loading:false});
      console.error(error);
    }
  };

  render() {
    const { classes, className, ...rest } = this.props;
    const {
      values,
      touched,
      errors,
      isValid,
      loading
    } = this.state;

    const showCurrentPasswordError =
      touched.currentPassword && errors.currentPassword ? errors.currentPassword[0] : false;
    const showNewPasswordError =
      touched.newPassword && errors.newPassword ? errors.newPassword[0] : false;
    const showConfirmNewPasswordError =
      touched.confirmNewPassword && errors.confirmNewPassword ? errors.confirmNewPassword[0] : false;

    const rootClassName = classNames(classes.root, className);

    return (
      <Portlet
        {...rest}
        className={rootClassName}
      >
        <PortletHeader>
          <PortletLabel
            title="Reset Password"
          />
        </PortletHeader>
        <PortletContent noPadding>
          <form
            autoComplete="off"
            noValidate
          >
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Current Password"
                margin="dense"
                required
                value={values.currentPassword}
                variant="outlined"
                type="password"
                InputLabelProps={{ shrink: true }}
                helperText={showCurrentPasswordError && errors.currentPassword[0]}
                onChange={event =>
                  this.handleFieldChange('currentPassword', event.target.value)
                }
              />
            </div>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="New Password"
                margin="dense"
                required
                value={values.newPassword}
                variant="outlined"
                type="password"
                InputLabelProps={{ shrink: true }}
                helperText={showNewPasswordError && errors.newPassword[0]}
                onChange={event =>
                  this.handleFieldChange('newPassword', event.target.value)
                }
              />
            </div>
            <div className={classes.field}>
              <TextField
                className={classes.textField}
                label="Confirm New Password"
                margin="dense"
                required
                value={values.confirmNewPassword}
                variant="outlined"
                type="password"
                InputLabelProps={{ shrink: true }}
                helperText={showConfirmNewPasswordError && errors.confirmNewPassword[0]}
                onChange={event =>
                  this.handleFieldChange('confirmNewPassword', event.target.value)
                }
              />
             </div>
          </form>
        </PortletContent>
        <PortletFooter className={classes.portletFooter}>
        {loading ? (
          <CircularProgress className={classes.progress} />
        ) : (
          <Button
            color="primary"
            variant="contained"
            onClick={this.handleResetPassword}
            disabled={!isValid}
          >
            Change Password
          </Button>
        )}
        </PortletFooter>
      </Portlet>
    );
  }
}

AccountResetPassword.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  updatePassword: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps,{updatePassword})
)(AccountResetPassword);